"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _mobxReact = require("mobx-react");
var _mobx = require("mobx");
var _utils = require("@seedlang/utils");
var _state = require("@seedlang/state");
var _constants = require("@seedlang/constants");
var _src = require("@seedlang/utils/src");
var _lodash = require("lodash");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
var VocabWordWrapper = function VocabWordWrapper(Component) {
  var _dec, _class, _class2, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9;
  return _dec = _mobx.observable.ref, (0, _mobxReact.observer)(_class = (_class2 = /*#__PURE__*/function (_React$Component) {
    function _class2(props) {
      var _props$route;
      var _this;
      _classCallCheck(this, _class2);
      _this = _callSuper(this, _class2, [props]);
      _initializerDefineProperty(_this, "sentence", _descriptor, _this);
      _initializerDefineProperty(_this, "expandedId", _descriptor2, _this);
      _initializerDefineProperty(_this, "autoPlay", _descriptor3, _this);
      _initializerDefineProperty(_this, "sentencesLoaded", _descriptor4, _this);
      _initializerDefineProperty(_this, "verbConjugationsLoaded", _descriptor5, _this);
      _initializerDefineProperty(_this, "conjugationsError", _descriptor6, _this);
      _initializerDefineProperty(_this, "showSourceInput", _descriptor7, _this);
      _initializerDefineProperty(_this, "loadingNewWord", _descriptor8, _this);
      _initializerDefineProperty(_this, "dictionaryNavigation", _descriptor9, _this);
      _this.onNextDictionaryWord = /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var _this$props$navigatio, _this$props$navigatio2;
        var navigation, currentWordId, position, cachedWordId, wordId;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              if (!_this.dictionaryNavigation.loading) {
                _context.n = 1;
                break;
              }
              return _context.a(2);
            case 1:
              navigation = _this.dictionaryNavigation;
              currentWordId = _this.wordId;
              position = navigation.position(currentWordId);
              cachedWordId = position === null || position === void 0 ? void 0 : position.wordIds[position.index + 1];
              if (!cachedWordId) {
                _context.n = 2;
                break;
              }
              _this.onClickWord(navigation.word(cachedWordId), {
                dictionaryNavigation: navigation.context
              });
              return _context.a(2);
            case 2:
              _context.n = 3;
              return navigation.adjacent(currentWordId, 1);
            case 3:
              wordId = _context.v;
              if (!_this.unmounted && ((_this$props$navigatio = _this.props.navigation) === null || _this$props$navigatio === void 0 || (_this$props$navigatio2 = _this$props$navigatio.isFocused) === null || _this$props$navigatio2 === void 0 ? void 0 : _this$props$navigatio2.call(_this$props$navigatio)) !== false && navigation === _this.dictionaryNavigation && currentWordId === _this.wordId && wordId) {
                _this.onClickWord(navigation.word(wordId), {
                  dictionaryNavigation: navigation.context
                });
              }
            case 4:
              return _context.a(2);
          }
        }, _callee);
      }));
      _this.expandSourceInput = function () {
        _this.showSourceInput = true;
      };
      _this.playSentenceVideo = function (sentence) {
        _this.autoPlay = true;
        _this.sentence = sentence;
      };
      _this.afterGetWord = function (resp) {
        var existingWord = _this.wordStore.showData;
        var preservedProgressData = {};
        if (existingWord && existingWord.id === resp.id) {
          if ((0, _utils.isPresent)(existingWord.consecutiveGoodScores) && (0, _src.isBlank)(resp.consecutiveGoodScores)) {
            preservedProgressData.consecutiveGoodScores = existingWord.consecutiveGoodScores;
          }
          if ((0, _utils.isPresent)(existingWord.viewsCount) && (0, _src.isBlank)(resp.viewsCount)) {
            preservedProgressData.viewsCount = existingWord.viewsCount;
          }
        }
        _this.sentence = null;
        _this.autoPlay = false;
        _this.expandedId = null;
        _this.showSourceInput = false;
        _this.conjugatedVerbStringStore.clearIndexData();
        var wordData = _objectSpread(_objectSpread({}, resp), preservedProgressData);
        _this.wordStore.setShowData(wordData);
        _this.loadingNewWord = false;
        _this.getConjugations();
        _state.AppUI.createEvent('vocab - view word page', {
          language_id: _this.word.languageId,
          target_text: _this.word.targetText
        });
      };
      _this.getConjugations = function () {
        if (_this.word.isVerb) {
          var request = {};
          _this.conjugationsRequest = request;
          _this.conjugationsError = false;
          var onError = function onError() {
            if (_this.conjugationsRequest !== request) return;
            _this.conjugationsRequest = null;
            _this.conjugationsError = true;
          };
          _this.conjugatedVerbStringStore.getIndex({
            ids: {
              wordId: _this.wordId
            },
            failureCallback: onError,
            onRequestError: onError
          }, function (resp) {
            if (_this.conjugationsRequest !== request) return;
            _this.conjugationsRequest = null;
            _this.afterGetConjugatedVerbStrings(resp);
          });
        } else {
          _this.verbConjugationsLoaded = true;
        }
      };
      _this.afterGetConjugatedVerbStrings = function (resp) {
        _this.conjugatedVerbStringStore.setIndexData(resp);
        _this.verbConjugationsLoaded = true;
      };
      _this.onClickSentence = function (sentence) {
        _this.popupSentence = sentence;
      };
      _this.onToggleSourceInput = function () {
        _this.showSourceInput = !_this.showSourceInput;
      };
      _this.afterSubmitSourceInput = function () {
        _this.wordStore.getShow({
          ids: {
            wordId: _this.wordId
          }
        });
      };
      _this.playWordVideo = function () {
        _this.autoPlay = true;
        _this.sentence = null;
      };
      _this.onClickRow = function (id) {
        _this.expandedId = _this.expandedId === id ? null : id;
      };
      _this.onClickWord = function (word) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        if (!(0, _utils.isPresent)(word)) {
          return;
        }
        if (_state.AppUI.layout.isNative) {
          var _this$props$route, _this$props$navigatio3;
          var wordStoreId = _state.AppUI.createWordStore(word);
          var screenName = ((_this$props$route = _this.props.route) === null || _this$props$route === void 0 ? void 0 : _this$props$route.name) || 'VocabWord';
          var showVideoLoadingSpinner = Boolean(options.showVideoLoadingSpinner);
          if ((_this$props$navigatio3 = _this.props.navigation) !== null && _this$props$navigatio3 !== void 0 && _this$props$navigatio3.push) {
            _this.props.navigation.push(screenName, {
              wordId: word.id,
              wordStoreId: wordStoreId,
              showVideoLoadingSpinner: showVideoLoadingSpinner,
              dictionaryNavigation: options.dictionaryNavigation
            });
          } else {
            var _this$props$navigatio4;
            (_this$props$navigatio4 = _this.props.navigation) === null || _this$props$navigatio4 === void 0 || _this$props$navigatio4.navigate(screenName, {
              wordId: word.id,
              wordStoreId: wordStoreId,
              showVideoLoadingSpinner: showVideoLoadingSpinner,
              dictionaryNavigation: options.dictionaryNavigation
            });
          }
        } else if ((0, _utils.isPresent)(_this.props.card) || _this.props.useOverlayNavigation) {
          _state.DeckUI.gotoWordVocabCard(word);
        } else if (!_state.VocabUI.layout.isNative) {
          _this.loadingNewWord = true;
          _this.verbConjugationsLoaded = false;
          _state.VocabUI.setWord(word);
          _state.AppUI.routeStore.routeToNamed('vocab.word', {
            wordId: word.id
          });
        }
      };
      _this.getWord = function () {
        _this.loadingNewWord = true;
        _this.verbConjugationsLoaded = false;
        _this.conjugationsError = false;
        _this.conjugationsRequest = null;
        _this.wordSentenceStore.loadForWord(_this.wordId);
        var request = {};
        _this.wordRequest = request;
        var onError = function onError() {
          if (_this.wordRequest === request) _this.wordRequest = null;
        };
        _this.wordStore.getShow({
          ids: {
            wordId: _this.wordId
          }
        }, function (resp) {
          if (_this.wordRequest !== request) return;
          _this.wordRequest = null;
          _this.afterGetWord(resp);
        }, {
          failureCallback: onError,
          onRequestError: onError
        });
      };
      _this.dictionaryNavigation = new _state.DictionaryNavigation((_props$route = props.route) === null || _props$route === void 0 || (_props$route = _props$route.params) === null || _props$route === void 0 ? void 0 : _props$route.dictionaryNavigation);
      if ((0, _utils.isPresent)(_this.wordId)) {
        _this.loadingNewWord = true;
        _this.getWord();
      } else if (!_state.AppUI.layout.isNative && _this.wordStore.hasShowData) {
        _this.getConjugations();
      }
      return _this;
    }
    _inherits(_class2, _React$Component);
    return _createClass(_class2, [{
      key: "componentDidUpdate",
      value: function componentDidUpdate(prevProps) {
        var _prevProps$route, _this$props$route2, _prevProps$route2, _prevProps$route3;
        if (((_prevProps$route = prevProps.route) === null || _prevProps$route === void 0 || (_prevProps$route = _prevProps$route.params) === null || _prevProps$route === void 0 ? void 0 : _prevProps$route.dictionaryNavigation) !== ((_this$props$route2 = this.props.route) === null || _this$props$route2 === void 0 || (_this$props$route2 = _this$props$route2.params) === null || _this$props$route2 === void 0 ? void 0 : _this$props$route2.dictionaryNavigation)) {
          var _this$props$route3;
          this.dictionaryNavigation = new _state.DictionaryNavigation((_this$props$route3 = this.props.route) === null || _this$props$route3 === void 0 || (_this$props$route3 = _this$props$route3.params) === null || _this$props$route3 === void 0 ? void 0 : _this$props$route3.dictionaryNavigation);
        }
        var prevWordStoreId = (0, _utils.isPresent)(prevProps.params) ? prevProps.params.wordStoreId : (_prevProps$route2 = prevProps.route) === null || _prevProps$route2 === void 0 || (_prevProps$route2 = _prevProps$route2.params) === null || _prevProps$route2 === void 0 ? void 0 : _prevProps$route2.wordStoreId;
        var prevWordId = (0, _utils.isPresent)(prevProps.params) ? prevProps.params.wordId : (_prevProps$route3 = prevProps.route) === null || _prevProps$route3 === void 0 || (_prevProps$route3 = _prevProps$route3.params) === null || _prevProps$route3 === void 0 ? void 0 : _prevProps$route3.wordId;
        if (prevWordStoreId !== this.wordStoreId || !this.wordStore.hasShowData && !this.wordRequest || (0, _utils.isPresent)(this.wordId) && (0, _utils.isPresent)(prevWordId) && prevWordId !== this.wordId) {
          this.getWord();
        }
      }
    }, {
      key: "componentWillUnmount",
      value: function componentWillUnmount() {
        this.wordRequest = null;
        this.conjugationsRequest = null;
        if (this.wordStoreId) {
          _state.AppUI.destroyWordStore(this.wordStoreId);
        } else if ((0, _src.isBlank)(this.props.wordStore)) {
          _state.AppUI.wordStore.clearShowData();
          _state.AppUI.conjugatedVerbStringStore.clearIndexData();
        }
        _state.AppUI.cardStore.clearIndexData();
        this.unmounted = true;
      }
    }, {
      key: "canNavigateToNextDictionaryWord",
      get: function get() {
        return this.dictionaryNavigation.canNavigate(this.wordId, 1);
      }
    }, {
      key: "hasVerbConjugations",
      get: function get() {
        return this.conjugatedVerbStringStore.hasIndexData;
      }
    }, {
      key: "showSpinner",
      get: function get() {
        return this.loadingNewWord;
      }
    }, {
      key: "hasVideoClip",
      get: function get() {
        return (0, _utils.isPresent)(this.videoClip) && this.videoClip.mp4Url;
      }
    }, {
      key: "reviewWord",
      get: function get() {
        var _this$word;
        return ((_this$word = this.word) === null || _this$word === void 0 ? void 0 : _this$word.rootWord) || this.word;
      }
    }, {
      key: "hasSentence",
      get: function get() {
        return (0, _utils.isPresent)(this.sentence);
      }
    }, {
      key: "hasWord",
      get: function get() {
        return this.wordStore.hasShowData;
      }
    }, {
      key: "word",
      get: function get() {
        return this.wordStore.showData;
      }
    }, {
      key: "selectedSynonymAssociation",
      get: function get() {
        var _this$props$card, _this$props$route4, _this$word2, _this$props$card2;
        var synonymAssociationId = ((_this$props$card = this.props.card) === null || _this$props$card === void 0 ? void 0 : _this$props$card.synonymAssociationId) || ((_this$props$route4 = this.props.route) === null || _this$props$route4 === void 0 || (_this$props$route4 = _this$props$route4.params) === null || _this$props$route4 === void 0 ? void 0 : _this$props$route4.synonymAssociationId);
        if (!synonymAssociationId) {
          return null;
        }
        var synonymAssociations = [].concat(_toConsumableArray(((_this$word2 = this.word) === null || _this$word2 === void 0 ? void 0 : _this$word2.synonymAssociations) || []), _toConsumableArray(((_this$props$card2 = this.props.card) === null || _this$props$card2 === void 0 || (_this$props$card2 = _this$props$card2.word) === null || _this$props$card2 === void 0 ? void 0 : _this$props$card2.synonymAssociations) || []));
        return synonymAssociations.find(function (item) {
          return String(item.id) === String(synonymAssociationId);
        });
      }
    }, {
      key: "wordStoreId",
      get: function get() {
        var _this$props$params, _this$props$route5;
        if (this.props.wordStoreId) {
          return this.props.wordStoreId;
        }
        if ((_this$props$params = this.props.params) !== null && _this$props$params !== void 0 && _this$props$params.wordStoreId) {
          return this.props.params.wordStoreId;
        }
        if ((_this$props$route5 = this.props.route) !== null && _this$props$route5 !== void 0 && (_this$props$route5 = _this$props$route5.params) !== null && _this$props$route5 !== void 0 && _this$props$route5.wordStoreId) {
          return this.props.route.params.wordStoreId;
        }
      }
    }, {
      key: "wordStore",
      get: function get() {
        if (this.props.wordStore) {
          return this.props.wordStore;
        }
        return _state.AppUI.getWordStore(this.wordStoreId);
      }
    }, {
      key: "wordSentenceStore",
      get: function get() {
        if (this.props.wordSentenceStore) {
          return this.props.wordSentenceStore;
        }
        return _state.AppUI.getWordSentenceStore(this.wordStoreId);
      }
    }, {
      key: "conjugatedVerbStringStore",
      get: function get() {
        if (this.props.conjugatedVerbStringStore) {
          return this.props.conjugatedVerbStringStore;
        }
        return _state.AppUI.getConjugatedVerbStringStore(this.wordStoreId);
      }
    }, {
      key: "showNoPlural",
      get: function get() {
        return this.word.isNoun && this.word.noPlural;
      }
    }, {
      key: "showPlural",
      get: function get() {
        return this.word.isNoun && !this.word.noPlural && (0, _utils.isPresent)(this.word.pluralNoun);
      }
    }, {
      key: "videoClip",
      get: function get() {
        if (this.sentence && this.sentence.target) {
          return this.sentence.target.videoClip;
        } else if (this.word && this.word.target && this.word.target.videoClip) {
          return this.word.target.videoClip;
        }
      }
    }, {
      key: "supplementVideoClip",
      get: function get() {
        return this.sentence && this.sentence.videoClip;
      }
    }, {
      key: "supplementImageUrl",
      get: function get() {
        return this.sentence && this.sentence.hasImage && this.sentence.image.url;
      }
    }, {
      key: "vocabCardVideoClip",
      get: function get() {
        var _this$word3;
        return this.videoClip || ((_this$word3 = this.word) === null || _this$word3 === void 0 || (_this$word3 = _this$word3.rootWord) === null || _this$word3 === void 0 || (_this$word3 = _this$word3.target) === null || _this$word3 === void 0 ? void 0 : _this$word3.videoClip);
      }
    }, {
      key: "vocabCardHasVideoClip",
      get: function get() {
        return (0, _utils.isPresent)(this.vocabCardVideoClip) && this.vocabCardVideoClip.mp4Url;
      }
    }, {
      key: "vocabCardMatchesCurrentCardTranslation",
      get: function get() {
        var _this$word4, _this$reviewWord, _DeckUI$currentCard, _DeckUI$currentCard2, _DeckUI$currentCard3;
        var vocabWordIds = [(_this$word4 = this.word) === null || _this$word4 === void 0 ? void 0 : _this$word4.id, (_this$reviewWord = this.reviewWord) === null || _this$reviewWord === void 0 ? void 0 : _this$reviewWord.id].filter(_utils.isPresent).map(String);
        var currentCardWordIds = [(_DeckUI$currentCard = _state.DeckUI.currentCard) === null || _DeckUI$currentCard === void 0 ? void 0 : _DeckUI$currentCard.translationId, (_DeckUI$currentCard2 = _state.DeckUI.currentCard) === null || _DeckUI$currentCard2 === void 0 ? void 0 : _DeckUI$currentCard2.wordId, (_DeckUI$currentCard3 = _state.DeckUI.currentCard) === null || _DeckUI$currentCard3 === void 0 || (_DeckUI$currentCard3 = _DeckUI$currentCard3.word) === null || _DeckUI$currentCard3 === void 0 ? void 0 : _DeckUI$currentCard3.id].filter(_utils.isPresent).map(String);
        return vocabWordIds.some(function (id) {
          return currentCardWordIds.includes(id);
        });
      }
    }, {
      key: "vocabCardWordIsCorrectWordType",
      get: function get() {
        var _this$word5, _this$word6;
        var wordTypeId = ((_this$word5 = this.word) === null || _this$word5 === void 0 ? void 0 : _this$word5.rootWordTypeId) || ((_this$word6 = this.word) === null || _this$word6 === void 0 ? void 0 : _this$word6.wordTypeId);
        return _constants.Constants.VOCAB_WORD_TYPES.map(function (item) {
          return item.id;
        }).includes(wordTypeId);
      }
    }, {
      key: "showVocabCardVideo",
      get: function get() {
        var _this$props$params2, _this$props$route6;
        var showVideoLoadingSpinner = ((_this$props$params2 = this.props.params) === null || _this$props$params2 === void 0 ? void 0 : _this$props$params2.showVideoLoadingSpinner) || ((_this$props$route6 = this.props.route) === null || _this$props$route6 === void 0 || (_this$props$route6 = _this$props$route6.params) === null || _this$props$route6 === void 0 ? void 0 : _this$props$route6.showVideoLoadingSpinner);
        if (this.loadingNewWord && showVideoLoadingSpinner) {
          return !this.vocabCardMatchesCurrentCardTranslation;
        }
        return Boolean(this.vocabCardHasVideoClip) && !this.vocabCardMatchesCurrentCardTranslation;
      }
    }, {
      key: "shouldShowVocabVideo",
      get: function get() {
        var _this$vocabCardVideoC;
        return Boolean((_this$vocabCardVideoC = this.vocabCardVideoClip) === null || _this$vocabCardVideoC === void 0 ? void 0 : _this$vocabCardVideoC.mp4Url);
      }
    }, {
      key: "showVocabCardReviewToggle",
      get: function get() {
        var _this$word7, _this$word8;
        return !this.props.backend && this.vocabCardHasVideoClip && !((_this$word7 = this.word) !== null && _this$word7 !== void 0 && _this$word7.targetTextContainsNumber) && this.vocabCardWordIsCorrectWordType && (!((_this$word8 = this.word) !== null && _this$word8 !== void 0 && _this$word8.rootWord) || !this.word.rootWord.excludeFromPublicLists) && !(_state.DeckUI.reviewDeck && this.vocabCardMatchesCurrentCardTranslation);
      }
    }, {
      key: "isShowingMeanings",
      get: function get() {
        var _AppUI$user, _this$word9, _this$word0, _AppUI$user2;
        return ((_AppUI$user = _state.AppUI.user) === null || _AppUI$user === void 0 ? void 0 : _AppUI$user.showMeanings) && (((_this$word9 = this.word) === null || _this$word9 === void 0 || (_this$word9 = _this$word9.meanings) === null || _this$word9 === void 0 ? void 0 : _this$word9.length) > 0 || ((_this$word0 = this.word) === null || _this$word0 === void 0 || (_this$word0 = _this$word0.meaningSourcePreviews) === null || _this$word0 === void 0 ? void 0 : _this$word0.length) > 0) && ((_AppUI$user2 = _state.AppUI.user) === null || _AppUI$user2 === void 0 ? void 0 : _AppUI$user2.showVocabMeanings) !== false;
      }
    }, {
      key: "shouldShowSynonyms",
      get: function get() {
        var _this$word1, _this$word10;
        return !this.isShowingMeanings && ((_this$word1 = this.word) === null || _this$word1 === void 0 || (_this$word1 = _this$word1.synonymAssociations) === null || _this$word1 === void 0 ? void 0 : _this$word1.some(function (item) {
          var _item$synonym;
          return (_item$synonym = item.synonym) === null || _item$synonym === void 0 ? void 0 : _item$synonym.publicInVocab;
        })) && ((_this$word10 = this.word) === null || _this$word10 === void 0 || (_this$word10 = _this$word10.publicSynonyms) === null || _this$word10 === void 0 ? void 0 : _this$word10.length) > 0;
      }
    }, {
      key: "shouldShowRelatedWords",
      get: function get() {
        var _this$relatedWords;
        return ((_this$relatedWords = this.relatedWords) === null || _this$relatedWords === void 0 ? void 0 : _this$relatedWords.length) > 0;
      }
    }, {
      key: "shouldShowRelatedPhrases",
      get: function get() {
        var _this$relatedPhrases;
        return ((_this$relatedPhrases = this.relatedPhrases) === null || _this$relatedPhrases === void 0 ? void 0 : _this$relatedPhrases.length) > 0;
      }
    }, {
      key: "relatedWordSections",
      get: function get() {
        return [this.shouldShowSynonyms && {
          title: 'Synonyms',
          words: this.word.publicSynonyms
        }, this.shouldShowRelatedWords && {
          title: 'Related Words',
          words: this.relatedWords
        }, this.shouldShowRelatedPhrases && {
          title: 'Phrases',
          words: this.relatedPhrases
        }].filter(function (item) {
          return item;
        });
      }
    }, {
      key: "shouldShowConjugationRow",
      get: function get() {
        var _this$word11, _this$word12, _this$word13;
        return Boolean(((_this$word11 = this.word) === null || _this$word11 === void 0 ? void 0 : _this$word11.isVerb) && ((_this$word12 = this.word) === null || _this$word12 === void 0 ? void 0 : _this$word12.conjugatedVerbStringsSummary) && ((_this$word13 = this.word) === null || _this$word13 === void 0 || (_this$word13 = _this$word13.conjugatedVerbStrings) === null || _this$word13 === void 0 ? void 0 : _this$word13.length) > 0);
      }
    }, {
      key: "shouldShowConceptRows",
      get: function get() {
        var _this$word14;
        return Boolean(((_this$word14 = this.word) === null || _this$word14 === void 0 || (_this$word14 = _this$word14.concepts) === null || _this$word14 === void 0 ? void 0 : _this$word14.length) > 0);
      }
    }, {
      key: "conjugationPreview",
      get: function get() {
        var _this$word15;
        return (_this$word15 = this.word) !== null && _this$word15 !== void 0 && _this$word15.isVerb ? this.word.conjugatedVerbStringsSummary : null;
      }
    }, {
      key: "showConjugationsTab",
      get: function get() {
        var _this$word16;
        return ((_this$word16 = this.word) === null || _this$word16 === void 0 ? void 0 : _this$word16.isVerb) && (!this.verbConjugationsLoaded || this.hasVerbConjugations || this.conjugationsError);
      }
    }, {
      key: "tabs",
      get: function get() {
        var _this$word17, _this$word18;
        var tabs = [{
          name: 'sentences',
          label: 'Sentences with Videos',
          "default": true
        }];
        tabs.push({
          name: 'comments',
          label: "".concat((0, _utils.isPresent)((_this$word17 = this.word) === null || _this$word17 === void 0 ? void 0 : _this$word17.commentsCount) ? "".concat(this.word.commentsCount, " ") : '', "Comment").concat(this.word.commentsCount === 1 || (0, _src.isBlank)((_this$word18 = this.word) === null || _this$word18 === void 0 ? void 0 : _this$word18.commentsCount) ? '' : 's')
        });
        if (this.showConjugationsTab) {
          tabs.push({
            name: 'conjugations',
            label: _state.AppUI.layout.isMobile || _state.AppUI.layout.isNative ? 'Conjugations' : 'Verb Conjugations'
          });
        }
        return tabs;
      }
    }, {
      key: "wordId",
      get: function get() {
        var _this$props$params3, _this$props$route7, _this$props$word;
        if ((_this$props$params3 = this.props.params) !== null && _this$props$params3 !== void 0 && _this$props$params3.wordId) {
          return this.props.params.wordId;
        }
        if ((_this$props$route7 = this.props.route) !== null && _this$props$route7 !== void 0 && (_this$props$route7 = _this$props$route7.params) !== null && _this$props$route7 !== void 0 && _this$props$route7.wordId) {
          var _this$props$route$par;
          return (_this$props$route$par = this.props.route.params) === null || _this$props$route$par === void 0 ? void 0 : _this$props$route$par.wordId;
        }
        if (this.props.wordId) {
          return this.props.wordId;
        }
        if ((_this$props$word = this.props.word) !== null && _this$props$word !== void 0 && _this$props$word.id) {
          return this.props.word.id;
        }
        if (this.wordStore.hasShowData) {
          return this.wordStore.showData.id;
        }
      }
    }, {
      key: "relatedWords",
      get: function get() {
        if ((0, _src.isBlank)(this.word) || (0, _src.isBlank)(this.word.relatedWords)) {
          return;
        }
        return (0, _lodash.uniqBy)(this.word.relatedWords.filter(function (item) {
          return item.publicInVocab;
        }), function (item) {
          return item.id;
        });
      }
    }, {
      key: "relatedPhrases",
      get: function get() {
        if ((0, _src.isBlank)(this.word) || (0, _src.isBlank)(this.word.relatedPhrases)) {
          return;
        }
        return (0, _lodash.uniqBy)(this.word.relatedPhrases.filter(function (item) {
          return item.publicPhrase;
        }), function (item) {
          return item.id;
        });
      }
    }, {
      key: "render",
      value: function render() {
        var _this$props$location, _this$word19;
        return /*#__PURE__*/_react["default"].createElement(Component, _extends({}, this.props, {
          key: (_this$props$location = this.props.location) !== null && _this$props$location !== void 0 && (_this$props$location = _this$props$location.state) !== null && _this$props$location !== void 0 && _this$props$location.dictionaryNavigation ? (_this$word19 = this.word) === null || _this$word19 === void 0 ? void 0 : _this$word19.id : undefined,
          canNavigateToNextDictionaryWord: this.canNavigateToNextDictionaryWord,
          dictionaryNavigationLoading: this.dictionaryNavigation.loading,
          dictionaryNavigationError: this.dictionaryNavigation.error,
          onNextDictionaryWord: this.onNextDictionaryWord,
          wordId: this.wordId,
          expandSourceInput: this.expandSourceInput,
          playSentenceVideo: this.playSentenceVideo,
          playWordVideo: this.playWordVideo,
          afterGetWord: this.afterGetWord,
          afterGetConjugatedVerbStrings: this.afterGetConjugatedVerbStrings,
          onToggleCreateReview: this.onToggleCreateReview,
          onToggleSourceInput: this.onToggleSourceInput,
          afterGetSentences: this.afterGetSentences,
          afterSubmitSourceInput: this.afterSubmitSourceInput,
          hasVerbConjugations: this.hasVerbConjugations,
          showSpinner: this.showSpinner,
          hasVideoClip: this.hasVideoClip,
          hasSentence: this.hasSentence,
          hasWord: this.hasWord,
          word: this.word,
          reviewWord: this.reviewWord,
          selectedSynonymAssociation: this.selectedSynonymAssociation,
          videoClip: this.videoClip,
          vocabCardVideoClip: this.vocabCardVideoClip,
          supplementVideoClip: this.supplementVideoClip,
          supplementImageUrl: this.supplementImageUrl,
          showVocabCardVideo: this.showVocabCardVideo,
          shouldShowVocabVideo: this.shouldShowVocabVideo,
          showVocabCardReviewToggle: this.showVocabCardReviewToggle,
          isShowingMeanings: this.isShowingMeanings,
          shouldShowSynonyms: this.shouldShowSynonyms,
          shouldShowRelatedWords: this.shouldShowRelatedWords,
          shouldShowRelatedPhrases: this.shouldShowRelatedPhrases,
          relatedWordSections: this.relatedWordSections,
          shouldShowConjugationRow: this.shouldShowConjugationRow,
          shouldShowConceptRows: this.shouldShowConceptRows,
          tabs: this.tabs,
          conjugationPreview: this.conjugationPreview,
          showConjugationsTab: this.showConjugationsTab,
          conjugationsError: this.conjugationsError,
          getConjugations: this.getConjugations,
          sentence: this.sentence,
          autoPlay: this.autoPlay,
          verbConjugationsLoaded: this.verbConjugationsLoaded,
          showSourceInput: this.showSourceInput,
          onClickSentence: this.onClickSentence,
          popupSentence: this.popupSentence,
          showNoPlural: this.showNoPlural,
          showPlural: this.showPlural,
          onClickRow: this.onClickRow,
          expandedId: this.expandedId,
          relatedWords: this.relatedWords,
          relatedPhrases: this.relatedPhrases,
          onClickWord: this.onClickWord,
          onToggleLearned: _state.VocabUI.onToggleLearned,
          getWord: this.getWord,
          wordStoreId: this.wordStoreId,
          wordStore: this.wordStore,
          wordSentenceStore: this.wordSentenceStore,
          conjugatedVerbStringStore: this.conjugatedVerbStringStore
        }));
      }
    }]);
  }(_react["default"].Component), _descriptor = _applyDecoratedDescriptor(_class2.prototype, "sentence", [_mobx.observable], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor2 = _applyDecoratedDescriptor(_class2.prototype, "expandedId", [_mobx.observable], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor3 = _applyDecoratedDescriptor(_class2.prototype, "autoPlay", [_mobx.observable], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function initializer() {
      return false;
    }
  }), _descriptor4 = _applyDecoratedDescriptor(_class2.prototype, "sentencesLoaded", [_mobx.observable], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function initializer() {
      return false;
    }
  }), _descriptor5 = _applyDecoratedDescriptor(_class2.prototype, "verbConjugationsLoaded", [_mobx.observable], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function initializer() {
      return false;
    }
  }), _descriptor6 = _applyDecoratedDescriptor(_class2.prototype, "conjugationsError", [_mobx.observable], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function initializer() {
      return false;
    }
  }), _descriptor7 = _applyDecoratedDescriptor(_class2.prototype, "showSourceInput", [_mobx.observable], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function initializer() {
      return false;
    }
  }), _descriptor8 = _applyDecoratedDescriptor(_class2.prototype, "loadingNewWord", [_mobx.observable], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function initializer() {
      return false;
    }
  }), _descriptor9 = _applyDecoratedDescriptor(_class2.prototype, "dictionaryNavigation", [_dec], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _applyDecoratedDescriptor(_class2.prototype, "canNavigateToNextDictionaryWord", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "canNavigateToNextDictionaryWord"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "hasVerbConjugations", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "hasVerbConjugations"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "showSpinner", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "showSpinner"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "hasVideoClip", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "hasVideoClip"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "reviewWord", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "reviewWord"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "hasSentence", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "hasSentence"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "hasWord", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "hasWord"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "word", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "word"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "selectedSynonymAssociation", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "selectedSynonymAssociation"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "wordStoreId", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "wordStoreId"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "wordStore", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "wordStore"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "wordSentenceStore", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "wordSentenceStore"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "conjugatedVerbStringStore", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "conjugatedVerbStringStore"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "showNoPlural", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "showNoPlural"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "showPlural", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "showPlural"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "videoClip", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "videoClip"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "supplementVideoClip", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "supplementVideoClip"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "supplementImageUrl", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "supplementImageUrl"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "vocabCardVideoClip", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "vocabCardVideoClip"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "vocabCardHasVideoClip", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "vocabCardHasVideoClip"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "vocabCardMatchesCurrentCardTranslation", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "vocabCardMatchesCurrentCardTranslation"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "vocabCardWordIsCorrectWordType", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "vocabCardWordIsCorrectWordType"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "showVocabCardVideo", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "showVocabCardVideo"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "shouldShowVocabVideo", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "shouldShowVocabVideo"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "showVocabCardReviewToggle", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "showVocabCardReviewToggle"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "isShowingMeanings", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "isShowingMeanings"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "shouldShowSynonyms", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "shouldShowSynonyms"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "shouldShowRelatedWords", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "shouldShowRelatedWords"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "shouldShowRelatedPhrases", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "shouldShowRelatedPhrases"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "relatedWordSections", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "relatedWordSections"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "shouldShowConjugationRow", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "shouldShowConjugationRow"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "shouldShowConceptRows", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "shouldShowConceptRows"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "conjugationPreview", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "conjugationPreview"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "showConjugationsTab", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "showConjugationsTab"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "tabs", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "tabs"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "wordId", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "wordId"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "relatedWords", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "relatedWords"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "relatedPhrases", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "relatedPhrases"), _class2.prototype), _class2)) || _class;
};
VocabWordWrapper.displayName = 'VocabWordWrapper';
var _default = exports["default"] = VocabWordWrapper;